import { render, staticRenderFns } from "./CategoriesModal.vue?vue&type=template&id=52a2d459&"
import script from "./CategoriesModal.vue?vue&type=script&lang=js&"
export * from "./CategoriesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports